module.exports = __webpack_public_path__ + "img/metier-01.92317144.jpg";